<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).ready(function() {
  // if ($(window).width() >= 768 && $(window).width() <= 990) {
  //     // Your code for the screen width between 768 and 990 pixels goes here
  //  $(".w45.icons_wrapper_nav .transcy-switcher-manual.transcy-desktop").remove();
  // const switcher = '<div class="transcy-switcher-manual transcy-desktop transcy-mobile hidden"></div>';
  //  $(".for_mobile_nav").html(switcher);
  // } else {
  //     // Your code for other screen widths goes here
  //     //console.log("Screen width is not between 768 and 990 pixels.");
  // }

setInterval(function(){
//$(".transcy-switcher-side .transcy-side__languages-header .transcy-label").text('Sprache/Langue');
//$(".transcy-switcher-side .transcy-switcher-footer .transcy-btn-apply .btn-apply").text('Übernehmen/Reprendre');
$("span.transcy-locale-name.transcy-country-locale-name.transcy-english-name").text("Schweiz");
//$(".transcy-switcher-side .transcy-side__languages-active .transcy-side__languages-content button.transcy-switcher-content__item[data-name='German']").text("Deutsch");
//$("span.transcy-switcher-language-and-currency").text("Deutsch");
},1000)

});   